import { format, getMonth, getDay, getHours, getDate } from 'date-fns';
import { fr } from 'date-fns/locale';

interface Surtitre { eyebrow: string; title: string; emphasis?: string }

export function getSurtitre(now = new Date()): Surtitre {
  const h = getHours(now);
  const dow = getDay(now);
  const day = getDate(now);
  const month = getMonth(now);

  if (month === 6 && day === 13) return { eyebrow: 'Veille de fête', title: 'Demain', emphasis: 'on danse' };
  if (month === 6 && day === 14) return { eyebrow: '14 juillet', title: 'Aujourd\'hui', emphasis: 'la fête nationale' };
  if (month === 11 && day === 24) return { eyebrow: 'Veille de Noël', title: 'Tout', emphasis: 'ralentit' };
  if (month === 11 && day === 31) return { eyebrow: 'Saint-Sylvestre', title: 'Une dernière', emphasis: 'fois cette année' };
  if (month === 3 && day === 1) return { eyebrow: '1er avril', title: 'Une journée', emphasis: 'de poissons' };

  const isWeekend = dow === 5 || dow === 6 || dow === 0;
  const isThuEve = dow === 4 && h >= 17;
  const isFriEve = dow === 5 && h >= 17;
  const isMorning = h >= 6 && h < 11;
  const isLunch = h >= 11 && h < 14;
  const isAfternoon = h >= 14 && h < 18;
  const isEvening = h >= 18 && h < 22;
  const isNight = h >= 22 || h < 6;

  if (isThuEve) return { eyebrow: 'Le week-end approche', title: 'Vendredi,', emphasis: 'ça commence' };
  if (isFriEve) return { eyebrow: 'Vendredi soir', title: 'Le rideau', emphasis: 'se lève' };
  if (dow === 6 && isMorning) return { eyebrow: 'Samedi matin', title: 'Quelques marchés', emphasis: 'à arpenter' };
  if (dow === 0 && isMorning) return { eyebrow: 'Dimanche', title: 'Une journée', emphasis: 'plus douce' };
  if (dow === 0 && isAfternoon) return { eyebrow: 'Dimanche après-midi', title: 'Le temps', emphasis: 'de flâner' };
  if (isWeekend && isEvening) return { eyebrow: 'Ce soir', title: 'Sept occasions', emphasis: 'de sortir' };

  if (isMorning) return { eyebrow: format(now, 'EEEE', { locale: fr }), title: 'Bonjour.', emphasis: 'Voici votre matinée' };
  if (isLunch) return { eyebrow: 'À midi', title: 'Une pause', emphasis: 'studieuse' };
  if (isAfternoon) return { eyebrow: 'Cet après-midi', title: 'Quelque chose', emphasis: 'à faire ?' };
  if (isEvening) return { eyebrow: 'Ce soir', title: 'Le programme', emphasis: 'des sorties' };
  if (isNight) return { eyebrow: 'Nuit', title: 'On vous laisse', emphasis: 'rêver' };

  return { eyebrow: format(now, 'EEEE d MMMM', { locale: fr }), title: 'À découvrir.' };
}
